import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { ThemeProvider } from '@mui/material/styles'

import { APIProvider } from 'hooks/useAPI'
import { AuthProvider } from 'hooks/useAuth'
import { EventProvider } from 'hooks/useEvent'
import { NewsProvider } from 'hooks/useNews'
import { theme } from 'theme'

import App from './App'

import './index.css'

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <CookiesProvider>
        <APIProvider>
          <AuthProvider>
            <EventProvider>
              <NewsProvider>
                <App />
              </NewsProvider>
            </EventProvider>
          </AuthProvider>
        </APIProvider>
      </CookiesProvider>
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById('root')
)
